var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M20.975,20.97474 L13.975,20.97474 C13.5375,20.97474 13.1,20.62474 13.1,20.09974 C13.1,19.66224 13.45,19.22474 13.975,19.22474 L19.225,19.22474 L19.225,12.22474 C19.225,11.78724 19.575,11.34974 20.1,11.34974 C20.5375,11.34974 20.975,11.69974 20.975,12.22474 L20.975,20.97474 Z M20.1,9.59974 C14.325,9.59974 9.6,14.32474 9.6,20.09974 C9.6,25.875615 14.325,30.59974 20.1,30.59974 C25.875,30.59974 30.6,25.875615 30.6,20.09974 C30.6,14.32474 25.875,9.59974 20.1,9.59974 L20.1,9.59974 Z",
    transform: "translate(-9 -9)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.eb550ba5dfb1c61ab05bdb3f114e556f.svg";
export { ForwardRef as ReactComponent };